export default __webpack_public_path__ + "static/media/print-mobile-2.542bf78b.png";